import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FascicoloLight } from 'src/app/common/models/fascicolo/fascicolo-light';
import { CssClassMapping } from 'src/app/core/configuration/css-class-mapping';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { RoutingConfigurationUtilService } from 'src/app/core/services/routing-configuration-util.service';
import { FrontEndMapping } from '../../../../core/configuration/front-end-mapping';
import { OperationsService } from '../../../../core/services/operations.service';
import { SearchResponse } from '../../../models/dto/search-response';
import { PraticaSelect } from '../../../models/pratica/intestazione-pratica/pratica-select';
import { PraticaBase } from '../../../models/pratica/pratica-base';
import { SearchPraticheComponent } from '../../input-component/searchPratiche/search-pratiche.component';

declare var closeModal: any;
declare var openModal: any;
declare var getPraticaMapSync: any;

@Component({
    selector: 'div [correla-pratica]',
  templateUrl: 'correla-pratica.component.html',
  styleUrls: ['./correla-pratica.component.css'],
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class CorrelaPraticaComponent implements OnInit, OnDestroy {
  @ViewChild('searchPratiche') searchPraticheComponent: SearchPraticheComponent;
  pratiche: PraticaSelect[];
  motivoCorrelazione: string;
  pratica: PraticaBase;
  urlCorrelaPratiche: string;
  tipoPratica: string;
  searchResponse: SearchResponse;
  afterViewInit: boolean = false;
  onPageCorrela: boolean = false;
  @Output() onReturn: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private operations: OperationsService, private router: Router, private frontEndMapping: FrontEndMapping, private routingService: RoutingConfigurationUtilService) {
  }

  ngOnInit() {
    if (this.router.url.indexOf('pratiche_correlate') !== -1) {
      this.onPageCorrela = true;
    } else {
      this.onPageCorrela = false;
    }
  }

  correlaPratiche() {
    let ids: string[] = [];
    for (let i = 0; i < this.pratiche.length; i++) {
      if (this.pratiche[i].selected) {
        ids.push(this.pratiche[i].id);
      }
    }
    this.operations.correlaPratiche(this.urlCorrelaPratiche, this.pratica.id, ids).subscribe(response => this.close(response));
  }

  getTipoPratica(pratica: PraticaBase) {
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(pratica.tipoPratica.id).subscribe(res => {
      tipoPratica = res;
    });
    return tipoPratica;
    // return FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
  }

  inizializza(pratica: PraticaBase) {
    this.pratiche = [];
    this.pratica = pratica;
    let praticaMap = this.getPraticaFromMap(this.pratica.tipoPratica.id);
    this.urlCorrelaPratiche = praticaMap.pathCorrela;
    this.frontEndMapping.getListTipiPratica(this.pratica.tipoPratica.id).subscribe(res => {
      this.tipoPratica = res; // FrontEndMapping.tipiPratica[this.pratica.tipoPratica.id];
    });
  }

//  public refresh(result: PraticaSelect[]) {
//    this.pratiche = [];
//    if (result) {
//      this.pratiche = result;
//    }
//  }

  public updatePraticheList(result: PraticaSelect[]) {
    if (result) {
      this.pratiche = this.pratiche.concat(result);
    }
  }

  public refresh(searchResponse,  reload: boolean = false) {
    this.searchResponse = searchResponse;
    if (searchResponse) {
      if (!reload) {
        this.pratiche = new Array<PraticaSelect>();
      }
      let pratiche_tmp = searchResponse.pratiche.filter(obj => obj.id != this.pratica.id);
      this.updatePraticheList(pratiche_tmp);
      //this.pratiche = this.pratiche.concat(<PraticaSelect>pratiche_tmp);
    } else {
      this.pratiche = new Array<PraticaSelect>();
    }
  }

  close(response) {
    this.searchPraticheComponent.searchText = '';
    closeModal('modalCorrelaPratica');
    this.onReturn.emit(response);
    if (this.onPageCorrela) {
        closeModal('modalCorrelaPraticaBis');
    }
  }

  reset(response) {
    for (let i = 0; i < this.pratiche.length; i++) {
      if (this.pratiche[i].selected) {
        this.pratiche[i].selected = false;
      }
    }
  }

  ngAfterViewInit() {
    this.afterViewInit = true;
  }

  private getPraticaFromMap(idTipoPraticaMap: any) {
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let pratica = getPraticaMapSync(idTipoPraticaMap);
    return pratica;
  }

  reloadSearch() {
    this.searchPraticheComponent.reloadCallback(this.pratiche.length);
  }

  getPraticaPathFromType(pratica: PraticaBase) {
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(pratica.tipoPratica.id).subscribe(res => {
      tipoPratica = res;
    });
    return tipoPratica;
    // return FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
  }

  getPraticaViewPath() {
    return ServicePathsSettings.VIEW_LABEL;
  }

  getCssClassCategoriaFascicolo(fascicolo: FascicoloLight) {
    if(fascicolo.tipoFascicolo && fascicolo.tipoFascicolo.categoria){   
      let categoriaMap = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
      return categoriaMap;
    }
  }


  getRoutingPath(fascicolo, pratica): string {
    let path: string;
    path = this.routingService.checkStatoFascicoloAndGetRoutingPath(fascicolo, pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
    return path;
  }

  ngOnDestroy(): void {
      closeModal('modalCorrelaPratica')
  }
}
